import React from "react";

export const CopyLink = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path
        d="M14.0374 7.10068H11.0588V8.58995H14.0374C15.266 8.58995 16.2713 9.5952 16.2713 10.8239C16.2713 12.0525 15.266 13.0578 14.0374 13.0578H11.0588V14.547H14.0374C16.0926 14.547 17.7606 12.879 17.7606 10.8239C17.7606 8.76866 16.0926 7.10068 14.0374 7.10068ZM9.56957 13.0578H6.59103C5.36239 13.0578 4.35713 12.0525 4.35713 10.8239C4.35713 9.5952 5.36239 8.58995 6.59103 8.58995H9.56957V7.10068H6.59103C4.53584 7.10068 2.86786 8.76866 2.86786 10.8239C2.86786 12.879 4.53584 14.547 6.59103 14.547H9.56957V13.0578ZM7.33567 10.0792H13.2927V11.5685H7.33567V10.0792Z"
        fill="black"
      />
    </svg>
  );
};
